module.exports = __webpack_public_path__ + "img/icon-boarlet.fe47409a.svg";